/**
 * `/zadania` — the trainer's whole attention queue, worked one card at a time.
 *
 * A path and a screen. Added 18 September 2026; the queue's two halves have been reachable in the
 * Pulpit's bento since the 15th, and this is where the rest of the work lives: a choice of snooze
 * term, bulk acts, an undo, and the room to read the item beside the decision. No search params in
 * v1 — the selection is a sitting, not an address. The one exception is `?scope=Triage|Feedback`
 * (3 November 2026): the half the deck OPENS on, so the Pulpit's summary line can lead to the
 * half it counted. The validator is the slice's.
 */

import { createFileRoute, useSearch } from '@tanstack/react-router';

import { SessionOverlay } from '~/pages/assigned-plan-calendar';
import { deckScopeOf, TasksScreen, validateTasksSearch } from '~/pages/tasks';

export const Route = createFileRoute('/_shell/zadania/')({
  validateSearch: validateTasksSearch,
  component: TasksRoute,
});

/**
 * The one session panel, laid over this screen by „Zobacz sesję" (owner, 25 September 2026) — the
 * panel the client detail lays over Przegląd, composed here because a page may not import a page.
 * It opens to READ, and offers no „Pokaż w planie": that walk is resolved per client on the client
 * detail, which this screen is not.
 */
function TasksRoute() {
  // `deckScopeOf` runs again here: the router merges the raw search under the validator's output,
  // so a value the validator dropped still arrives as the literal string.
  const scope = deckScopeOf(useSearch({ from: '/_shell/zadania/' }));
  return (
    <TasksScreen
      scope={scope}
      renderSessionPanel={(workoutExecutionId, onClose) => (
        <SessionOverlay
          key={workoutExecutionId}
          workoutExecutionId={workoutExecutionId}
          focusComment={false}
          onClose={onClose}
          onShowInPlan={null}
        />
      )}
    />
  );
}
